/*
                --- simple tab script ---
    - give the outer container the `js-tabs` class
    - give each selectable tab the `js-tab` class and a unique ID
    - give each tab selector a data attribute `data-tab-id` with
      the ID of the tab (excluding #)
    - script will toggle `active` class on tabs when tab is changed,
      so use that to apply your own styling
*/

function init() {
    let containers = document.querySelectorAll('.js-tabs');
    for(let i = 0; i<containers.length; i++) {
        let container = containers[i];

        // set up event listeners for tab controls
        let tabHeaders = container.querySelectorAll('[data-tab-id]');
        for(let j = 0; j<tabHeaders.length; j++) {
            let header = tabHeaders[j];

            header.addEventListener('click', () => {
                select(header, container);
            });
        }

        // automatically select the first tab
        select(tabHeaders[0], container);
    }
}

// adds `active` class to the given tab, and removes it from all others
function select(header, container) {
    let id = header.getAttribute('data-tab-id');
    let tab = container.querySelector('#' + id);

    if(!tab.classList.contains('active')) {
        hideAllChildren(container);
        tab.classList.add('active');
        header.classList.add('active');
        // if possible, could be changed to allow multiple
        // headers per item, but doesn't seem necessary now
    }
}

// removes `active` class from all tabs in a container
function hideAllChildren(container) {
    let children = container.querySelectorAll('.js-tab');
    for(let i = 0; i<children.length; i++) {
        let child = children[i];
        child.classList.remove('active');
    }

    let tabHeaders = container.querySelectorAll('[data-tab-id]');
    for(let j = 0; j<tabHeaders.length; j++) {
        let header = tabHeaders[j];
        header.classList.remove('active');
    }
}

module.exports = {
    init: init,
}



// WEBPACK FOOTER //
// ./modules/tabs.js